import { render, staticRenderFns } from "./DepreciationMenubar.vue?vue&type=template&id=a17c4640&scoped=true&"
import script from "./DepreciationMenubar.vue?vue&type=script&lang=js&"
export * from "./DepreciationMenubar.vue?vue&type=script&lang=js&"
import style0 from "./DepreciationMenubar.vue?vue&type=style&index=0&id=a17c4640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17c4640",
  null
  
)

export default component.exports